import requestTypes from "constants/requestTypes";
import { fetchNext } from "./request";

const APP_MARKET_URL = String(process.env.REACT_APP_MARKET_URL);
export const getColumn = async (marketTypeId, exchangeId, valueTypeId) => {
  const url = `${APP_MARKET_URL}/instruments/columns?marketTypeId=${marketTypeId}&valueTypeId=${valueTypeId}&exchangeId=${exchangeId}`;
  const resp = await fetchNext(requestTypes.GET, url, null);
  return resp;
};
